import { render, staticRenderFns } from "./newsEvents.vue?vue&type=template&id=077fab94&scoped=true&"
import script from "./newsEvents.vue?vue&type=script&lang=js&"
export * from "./newsEvents.vue?vue&type=script&lang=js&"
import style0 from "./newsEvents.vue?vue&type=style&index=0&id=077fab94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077fab94",
  null
  
)

export default component.exports